<p-toast position="center" [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<app-loader></app-loader>
<div class="change-password">
    <div class="top-headings">
        <div class="reset-text">
            <h4>Change Password</h4>
            <p>Your new password must be different from previously used passwords.</p>
        </div>
        
        <div class="close-icon">
            <img src="assets/images/export-close.svg" (click)="closeDialog()" alt="Close"/>
        </div>
    </div>

</div>
<div class="reset-body">
  <div *ngIf="errorMessageOld" class="validation-error pass-err">{{errorMessageOldMess}}</div>
    <form [formGroup]="resetPasswordForm" class="form">
        <div class="current-input">
            <label for="oldPassword">Current Password <span class="custom-star">*</span></label>
            <p-password class="small-placeholder" indicator="false" [toggleMask]="true" [feedback]=false id="oldPassword" placeholder="Enter Current Password" maxlength="15" (keydown)="onPasswordKeyDown($event, 'oldPassword')" formControlName="oldPassword"></p-password>
            <div class="error-outer">
                <small
                    *ngIf="resetPasswordForm.get('oldPassword').hasError('required') && (resetPasswordForm.get('oldPassword').dirty || resetPasswordForm.get('oldPassword').touched)"
                    class="validation-error">This field is required*</small>
                <small
                    *ngIf="resetPasswordForm.get('oldPassword').hasError('minlength') && (resetPasswordForm.get('oldPassword').touched || resetPasswordForm.get('oldPassword').dirty)"
                    class="validation-error">Minimum 3 characters are required*</small>
                <small
                    *ngIf="resetPasswordForm.get('oldPassword').hasError('maxlength') && (resetPasswordForm.get('oldPassword').touched || resetPasswordForm.get('oldPassword').dirty)"
                    class="validation-error">Miximum 15 characters are required*</small>
            </div>
        </div>
        <div class="current-input">
            <label for="newPassword">New Password <span class="custom-star">*</span></label>
            <p-password class="small-placeholder" indicator="false" [toggleMask]="true" [feedback]=false id="newPassword" placeholder="Enter New Password" maxlength="15" (keydown)="onPasswordKeyDown($event, 'newPassword')" formControlName="newPassword"></p-password>
            <div class="error-outer" >
                <div *ngIf="resetPasswordForm.get('newPassword').invalid && (resetPasswordForm.get('newPassword').dirty || resetPasswordForm.get('newPassword').touched)">
                    <small *ngIf="resetPasswordForm.get('newPassword').hasError('required')" class="validation-error">Password is required.</small>
                    <small *ngIf="resetPasswordForm.get('newPassword').hasError('invalidPassword')" class="validation-error">
                        Length must be 8-15 with uppercase, lowercase, number & special characters.
                    </small>
                </div>
            </div>
            
        </div>
        <div class="current-input">
            <label for="confirmPassword">Confirm Password <span class="custom-star">*</span></label>
            <p-password class="small-placeholder" indicator="false" [toggleMask]="true" [feedback]=false id="confirmPassword" placeholder="Enter Confirm Password" maxlength="15" (keydown)="onPasswordKeyDown($event, 'confirmPassword')" formControlName="confirmPassword"></p-password>
            <div class="error-outer"  >
                <div *ngIf="resetPasswordForm.get('confirmPassword').invalid && (resetPasswordForm.get('confirmPassword').dirty || resetPasswordForm.get('confirmPassword').touched)">
                    <small *ngIf="resetPasswordForm.get('confirmPassword').hasError('required')" class="validation-error">Password is required.</small>
                    <small *ngIf="resetPasswordForm.get('confirmPassword').hasError('invalidPassword')" class="validation-error">
                        Length must be 8-15 with uppercase, lowercase, number & special characters.
                    </small>
                </div>
              <h8  class="text-center" *ngIf="errorMessage" class="validation-error">Confirm Password should match the Password</h8>
            </div>
            
        </div>
        <div class="save-btn">
            <p-button label="Save Password" (onClick)="resetPassword(resetPasswordForm.value)"></p-button>
        </div>
    </form>
</div> 

